import React, { Component } from 'react';
import InputText, { InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline.jsx';
import FormLayout from '../containers/FormLayout.jsx';
import { Box, Button, Grid, TableRow, TableCell } from '@material-ui/core';
import { SingleSwitch } from '../../../../commonModules/MUI/RadioAndCheckbox.jsx';

class FormSale extends Component {
    state = { }

    handlePositiveNumberChange = (e) => {
        const { name, value } = e.target
        if (value === "") {
            this.props.handleChange(e)
            return
        }
        const parsed = parseFloat(value)
        if (!Number.isFinite(parsed)) {
            this.props.handleChange(e)
            return
        }
        const normalizedValue = String(Math.abs(parsed))
        if (normalizedValue === value) {
            this.props.handleChange(e)
            return
        }
        this.props.handleChange({
            target: {
                ...e.target,
                name,
                value: normalizedValue
            }
        })
    }
    
    createShopList = () => {
        const list = []
        const { SHOPS, AVAILABLE} = this.props
        if( AVAILABLE ){
            Object.keys(SHOPS).map( ID => { 
                const shop = SHOPS[ID]     
                let selected = !!shop.shop_disabled || this.props.sale.shop_id === ID
                // if(this.props.sale.shop_id === ID) {  // already selected   
                //     selected = true 
                // } 
                list.push (       
                    {value:ID, label:shop.name, disabled:selected} 
                )
            })
        }
        return list
    }

    render() {
        const shops = this.createShopList()
        return (
            <Grid className="card-text">
                <h4 className="card-title">Nouvelle Vente</h4>

                <Box p={2}>
                    <Grid container spacing={2} >
                        {this.props.fromResa && this.props.sale.shop_id &&
                            <Grid item xs={12}>
                                <InputText
                                    value={this.props.SHOPS[this.props.sale.shop_id].name || ""}
                                    error={this.props.errors.shop_id}
                                    label="Magasin"
                                /> 
                            </Grid>
                        }
                        <Grid item xs={12}>
                        {this.props.fromResa ?
                                <InputText
                                    value={"Pay As You Go"}
                                    error={this.props.errors.nature}
                                    label="Magasin"
                                /> :
                            <InputSelectMagasin
                                options={[
                                    {value:"payg", label:"Pay As You Go"},
                                    // {value:"installation", label:"Installation"},
                                    {value:"vente", label:"Vente"},
                                    // {value:"prepa", label:"Préparation de Commande"},
                                    // {value:"sav", label:"SAV"},
                                ]}
                                value={this.props.sale.natureDisplay}
                                onChange={(option)=>this.props.handleSelect(option,"nature")}
                                error={this.props.errors.nature}
                                label="Nature"
                            /> 
                        }
                        </Grid>
                        {(this.props.sale.nature === "payg"|| this.props.sale.nature === "vente") && !this.props.fromResa &&
                            <Grid item xs={12}>
                                <InputSelectMagasin
                                    options={
                                        // Les ventes PAYG sont uniquement pour la plateforme MyJouleBox
                                        this.props.sale.nature === "payg"
                                            ? [{value:"mjb", label:"Plateforme MyJouleBox"}]
                                            : [
                                                {value:"mjb", label:"Plateforme MyJouleBox"},
                                                {value:"other", label:"Autre plateforme"},
                                            ]
                                    }
                                    value={this.props.sale.cli_typeDisplay}
                                    onChange={(option) => this.props.handleSelect(option, "cli_type")}
                                    error={this.props.errors.cli_type}
                                    label="Type Client"
                                    // isOptionDisabled={(option) => option.disabled === true}
                                /> 
                            </Grid>
                        }
                        
                        {this.props.sale.nature !== "" && !this.props.fromResa &&
                            <Grid item xs={12}>
                                <InputSelectMagasin
                                    options={shops}
                                    value={this.props.sale.shop_idDisplay || {value:"", label:""}}
                                    onChange={(option) => this.props.handleSelect(option,"shop_id")}
                                    error={this.props.errors.shop_id}
                                    label="Magasin"
                                /> 
                            </Grid>
                        }
                        
                        <Grid item xs={12}>
                            <FormLayout 
                                {...this.props} 
                                title={"Produits"}
                                createAddForm={this.props.createAddFormP}
                                onClick={this.props.handleAddProd}
                                onClickForCSVUpload={this.props.handleAddProdByCSV}
                                colSpan={5}
                                showTVA={true}
                                isTVAExempt={this.props.sale.sale_tva}
                            /> 
                        
                        </Grid>
                        <Grid item xs={12}>
                            <SingleSwitch
                                color="primary"
                                label="Vente à Crédit ?"
                                labelPlacement="start"
                                name="sale_credit" 
                                checked={this.props.sale.sale_credit} 
                                onChange={
                                    (e) => this.props.handleCheck(e.target.checked, "sale_credit")
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <SingleSwitch
                                color="primary"
                                label="Facture exonérée de TVA ?"
                                labelPlacement="start"
                                name="sale_tva" 
                                checked={this.props.sale.sale_tva} 
                                onChange={
                                    (e) => this.props.handleCheck(e.target.checked, "sale_tva")
                                }
                            />
                        </Grid>
                        {this.props.sale.sale_credit &&
                            <Grid item xs={12}>
                                <InputText 
                                    onChange={this.props.handleChange} 
                                    value={this.props.sale.comments} 
                                    name="comments" 
                                    title="Modalités de paiement" 
                                    error={this.props.errors.comments} 
                                    required
                                    multiline
                                    rows={3} 
                                />
                            </Grid>
                        }
                        <Grid item sm={6}></Grid>
                        <Grid item sm={6} xs={12} className="text-left">
                            <InputText
                                type="number"
                                min={0}
                                step="0.01"
                                inputProps={{ min: 0, step: "0.01" }}
                                change={this.handlePositiveNumberChange}
                                value={this.props.sale.aib}
                                name="aib"
                                title="AIB/BIC prélevé sur le client"
                                error={this.props.errors.aib}
                            />
                            <InputText 
                                haserror={(this.props.errors.discount ? "has-error" : "")} 
                                change={this.props.handleChange} 
                                value={this.props.sale.discount} 
                                name="discount" 
                                title="Reduction" 
                                error={this.props.errors.discount} 
                                disabled 
                            />
                        
                            {/* Si exonéré de TVA : afficher seulement HT (= TTC) */}
                            {this.props.sale.sale_tva ? (
                                <InputText 
                                    haserror={(this.props.errors.total ? "has-error" : "")} 
                                    change={this.props.handleChange} 
                                    value={this.props.sale.total} 
                                    name="total" 
                                    title="TOTAL HT (Exonéré de TVA)" 
                                    error={this.props.errors.total} 
                                    disabled 
                                />
                            ) : (
                                /* Si avec TVA : afficher HT ET TTC */
                                <>
                                    <InputText 
                                        change={this.props.handleChange} 
                                        value={this.props.sale.totalHT ? parseFloat(this.props.sale.totalHT).toFixed(2) : ''} 
                                        title="TOTAL HT" 
                                        disabled 
                                    />
                                    <InputText 
                                        haserror={(this.props.errors.total ? "has-error" : "")} 
                                        change={this.props.handleChange} 
                                        value={this.props.sale.total} 
                                        name="total" 
                                        title="TOTAL TTC" 
                                        error={this.props.errors.total} 
                                        disabled 
                                    />
                                </>
                            )}
                        </Grid>
                    </Grid>
                        
                    <Box p={2} >
                        <div className="pull-right">
                            <Button color="secondary" variant="contained" onClick={this.props.validate}>Valider</Button>
                            <Button color="secondary" onClick={this.props.handleClose}>Annuler</Button>
                        </div>                    
                    </Box>
                </Box>
            </Grid>
        );
    }
}

export default FormSale;